// extracted by mini-css-extract-plugin
export default {"menuText":"#fff","menuActiveText":"#409EFF","subMenuActiveText":"#409EFF","menuBg":"#252D40","menuHover":"#ddd","subMenuBg":"#252D40","subMenuHover":"#ddd","sideBarWidth":"210px"};